import { render, staticRenderFns } from "./SignUpMultiselect.vue?vue&type=template&id=89ccf5fa&scoped=true"
import script from "./SignUpMultiselect.vue?vue&type=script&lang=js"
export * from "./SignUpMultiselect.vue?vue&type=script&lang=js"
import style0 from "./SignUpMultiselect.vue?vue&type=style&index=0&id=89ccf5fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ccf5fa",
  null
  
)

export default component.exports